module.exports = __webpack_public_path__ + "img/ico_download.4f5759bd.svg";